import { Typography } from "@material-ui/core";
import get from "lodash/get";
import React from "react";
import { ArrayField, ChipField, SingleFieldList } from "react-admin";

interface ICustomArrayChipField {
  source: string;
  chipSource: string;
  record?: object;
  label?: string;
}

const CustomArrayChipField = ({
  source,
  chipSource,
  record = {},
}: ICustomArrayChipField) => {
  const ChipFieldStyle = { margin: 0 };
  const datas = get(record, source);

  return (
    <>
      {datas && datas.length === 0 ? (
        <Typography>-</Typography>
      ) : (
        <ArrayField source={source}>
          <SingleFieldList linkType={false} style={ChipFieldStyle}>
            <ChipField source={chipSource} />
          </SingleFieldList>
        </ArrayField>
      )}
    </>
  );
};

export default CustomArrayChipField;
